// Общая механика выдвижной панели: Esc закрывает, а при открытии фокус
// уезжает в саму панель — иначе он остаётся на кнопке под затемнением, и
// управление с клавиатуры продолжает ходить по скрытому за ней экрану.
//
// Раньше эти три эффекта жили только внутри AppMenu. Когда рядом появился
// второй потребитель той же механики — единый мобильный сайдбар
// (MobileShellHeader) — переписывать их с нуля означало бы рано или поздно
// разойтись с AppMenu поведением по мелочи (например, забыть один из двух
// путей закрытия). Вынесены сюда, а AppMenu сам переведён на этот хук.
//
// Возврат фокуса на кнопку-триггер при закрытии — забота вызывающего кода,
// а не хука: он передаётся сюда уже встроенным в `close`, потому что кнопка
// в разных местах разная (бургер, кнопка меню сайдбара) и хранить на неё
// ref здесь было бы лишней связанностью.
import { useEffect, useRef } from 'react';

export function useDismissablePanel(open: boolean, close: () => void) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      close();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, close]);

  // Между открытием панели и этим эффектом кто-то другой (автофокус внутри
  // содержимого) фокус мог уже не забрать — сюда попадают и пустые панели.
  useEffect(() => {
    if (open) panelRef.current?.focus();
  }, [open]);

  return panelRef;
}
